
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardDescription, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { AuthLayout } from '@/components/auth/components/AuthLayout';

const InvalidLink = () => {
  const navigate = useNavigate();
  
  return (
    <AuthLayout>
      <Card className="w-full">
        <CardHeader>
          <CardTitle>Invalid Link</CardTitle>
          <CardDescription>
            This account setup link is invalid or has expired.
          </CardDescription>
        </CardHeader>
        <CardFooter>
          <Button onClick={() => navigate('/login')} className="w-full">
            Go to Login
          </Button>
        </CardFooter>
      </Card>
    </AuthLayout>
  );
};

export default InvalidLink;
